export const types = {
    IMPORTCSV: 'IMPORT-CSV',
    IMPORTJSON: 'IMPORT-JSON',
    IMPORTEXCEL: 'IMPORT-EXCEL',
    EXTERNAL: 'EXTERNAL',
};